var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorridorCallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4411 32.7459C40.3449 32.4561 39.9597 32.0697 39.5746 31.9731C35.6267 31.0072 31.6789 30.1378 27.7311 29.2684C27.4422 29.1718 26.9608 29.4616 26.7682 29.7514C26.1905 30.6208 25.709 31.5868 25.3239 32.5527C25.035 33.3255 24.6498 33.1323 23.7832 33.1323C19.7391 33.1323 9.43627 22.7965 9.53256 18.836C9.53256 17.9667 9.43627 17.6769 10.1103 17.2905C11.0732 16.9041 12.0361 16.3245 12.9027 15.8415C13.1915 15.6483 13.3841 15.1654 13.3841 14.8756C12.5175 10.9151 11.6509 6.95466 10.688 2.99421C10.5917 2.70442 10.3029 2.22144 9.91771 2.12484C5.48844 1.35207 0 4.05677 0 13.33C0 24.5352 15.5987 42.5987 29.1754 42.5987C38.5154 42.6953 41.2115 37.1893 40.4411 32.7459Z",
    fill: "#E1EAF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0977 11.1679L35.3319 5.9292",
    stroke: "#0071C2",
    strokeWidth: 2.61935,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.209 8.54839V2",
    stroke: "#0071C2",
    strokeWidth: 2.61935,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7148 18.3711H39.2577",
    stroke: "#0071C2",
    strokeWidth: 2.61935,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorridorCallIcon);
export default __webpack_public_path__ + "static/media/corridorCallIcon.7b54be46730175fef3a0a892cd87ad2d.svg";
export { ForwardRef as ReactComponent };